import React from "react"
import { useTranslation } from "react-i18next"

import { Breadcrumbs } from "~/components/Breadcrumbs/Breadcrumbs"
import { ButtonLink } from "~/components/Button/Button"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { Theme } from "~/components/Theme/Theme"
import { VideoWrapper } from "~/components/VideoWrapper/VideoWrapper"

import styles from "./index.module.css"

export const Hero: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Theme className={styles.Wrapper} theme="dark">
      <VideoWrapper defaultVideo="videoOne" loop />

      <div className="container">
        <Breadcrumbs />
        <div className="grid grid--col-12">
          <div className={styles.Grid}>
            <Heading className={styles.Title} like="h1">
              <Raw html={t("procurements.Hero.Title")} />
            </Heading>
            <div>
              <Raw html={t("procurements.Hero.Lead")} />
            </div>
            <div className={styles.Links}>
              <div className={styles.Link}>
                <a href="#offer">
                  <Raw html={t("procurements.Hero.Links.01")} />
                </a>
              </div>
              <div className={styles.Link}>
                <a href="#cards">
                  <Raw html={t("procurements.Hero.Links.02")} />
                </a>
              </div>
            </div>
            {/*<ButtonLink*/}
            {/*  className={styles.Button}*/}
            {/*  href="http://utp.sberbank-ast.ru/AFK/NBT/Index/0/0/0/0"*/}
            {/*  target="_blank"*/}
            {/*  view="xl"*/}
            {/*>*/}
            {/*  <Raw html={t("procurements.Hero.Button")} />*/}
            {/*</ButtonLink>*/}
          </div>
        </div>
      </div>
    </Theme>
  )
}
